import { isNil } from 'lodash';

export default {
  gameTitle: (state, getters) => {
    if (!isNil(getters.customProductName)) {
      return getters.customProductName;
    }
    return getters.translateProductName
      ? getters.translations[
          state.usePackageTranslations ? 'product_name' : 'pages_player_history_virtual_penalty_shootout'
        ]
      : 'Virtual Penalty Shootout';
  },
  customProductName: (state) => state.config.ui?.config?.customProductName,
  // TODO: Remove true default when all apps adapted and ensured all clients with custom/translated product name are adapted through static config
  translateProductName: (state) => state.config.ui?.config?.translateProductName ?? true,
  product_config: (state) => state.config.product,
  appLayout: (state) => state.config.appLayout,
  active_round: (state) => state.round.active,
  selected_round: (state) => state.round.selected,
  round_phase: (state) => state.round.phase,
  schedule: (state) => state.scheduleList.map((eventId) => state.schedule[eventId]),
  disabled_betting: (state) => state.round.disabled,
  odds: (state) => state.round.selected.odds,
  notification_active: (state) => state.notification.active,
  isIsonis: (state) => state.isonisCountryList.indexOf(state.config.taxAuthority) > -1,
  isTerminalLayout: (state) => state.layout === 'terminal',
  isTerminalChannel: (state) => state.config.applicationName?.toLowerCase() === 'terminal',
  userIsOperator: (state) =>
    state.terminalUserData.userType === 'OPERATOR' || state.terminalUserData.type === 'OPERATOR',
  isFreeBetMode: (state) => state.isFreeBetMode,
  isBoostActive: (state) => state.config.ui.config?.boost?.enabled || false,
  ajsDisabled: (state) => state.config?.ui?.config?.ajsDisabled ?? false,
  staticTheme: (state) => state.config.ui.config.theme ?? 'dark',
  isNextGen: (state) => state.config.platformName === 'NextGen',
  freeBetFeatureActive: (state) => state.config.ui.config.freeBetFeatureActive,
  customDomain: (state) => state.config.customDomain,
};
